module.exports = __webpack_public_path__ + "static/build-eca81b9c471b8a0b482418d5da462fdf.png";